import { Box, Grid, Typography } from "@mui/material";

const Section = ({ languages, metadata, classes }) =>
  metadata &&
  !Array.isArray(metadata) &&
  languages?.map((l) => (
    <Grid key={l.locale} item xs={12} sm={12} md={12}>
      <Grid container spacing={2}>
        <Grid item xs={3} sm={3} md={3}>
          {metadata?.og_image?.[l.locale]?.src && (
            <Box
              className={classes.imgBoxSquare}
              style={{
                backgroundImage: `url(${metadata.og_image[l.locale].src})`,
              }}
            />
          )}
        </Grid>
        <Grid item xs={9} sm={9} md={9}>
          <Typography variant="h6" className={classes.ogTitle}>
            {metadata.og_title?.[l.locale]}
          </Typography>
          <Typography variant="body1" className={classes.ogDescription}>
            {metadata.og_description?.[l.locale]}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  ));

export default Section;
